export enum ImageResolution {
  SM = '300',
  MD = '800',
  LG = '1500',
}
